/**
 * Labstep
 *
 * @module screens/Jupyter/Authorize
 * @desc Jupyter Authorize OAuth
 */

import { DocumentHead } from 'labstep-web/core/DocumentHead';
import type React from 'react';
import Center from './Center';
import type { JupyterAuthorizeScreenProps } from './types';

export const JupyterAuthorizeScreen: React.FC<
  JupyterAuthorizeScreenProps
> = ({ location }) => (
  <>
    <DocumentHead title="Jupyter Authorize" />
    <Center location={location} />
  </>
);
